import React, { useEffect, useState, useContext, useRef } from "react";
import { Button, Card, Grid, TextField, Divider, Select, MenuItem, IconButton, Checkbox } from "@mui/material";
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import OneTicketIcon from '../../img/icons/1ticket.svg';
import { selectDeliveryMethods, updateBuyRequest, updateBuyRequests, updateSwarm } from "../../store/slices/swarms";
import { useDispatch } from "react-redux";
import { useCreateBuyRequestMutation } from "../../services/swarmsApi";
import { useSelector } from "react-redux";
import { useLazyGetUserBuysQuery } from "../../services/eventApi";
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import { copyToClipBoard } from "../../utils";
import { toStdDate } from '../../utils/dates';
import { useNotification } from '../../context/NotificationContext';
import BasicModalInformation from "../../components/basicModalInformation";
import Chip from '@mui/material/Chip';
import SignalREncorehiveContext from "../../context/signalREncorehive";
import { eventDatesFormatter } from "../../utils/dates";
import { useDeliveryMethods } from "../../customHooks/useDeliveryMethods";
import { updateBeeSwarm } from "./store";

const SwarmCard = ({ selectedSwarm }) => {

  const { showNotification } = useNotification();

  const dispatch = useDispatch();
  const firstInputRef = useRef(null);

  const {deliveryMethods} = useDeliveryMethods();


  const selectedEvent = selectedSwarm.event;

  console.log("SWARMCARD, selectedSwarm: ", selectedSwarm)
  console.log("SWARMCARD, selectedEvent: ", selectedEvent)

  const [createBuyRequest, { data: buyRequestsCreated }] = useCreateBuyRequestMutation();
  const [getUserBuys, { data: userBuysRes, isLoading: loadingUserBuys, isError: errorLoadingUserBuys }] = useLazyGetUserBuysQuery({ refetchOnMountOrArgChange: true })
  const [sendRequestLoading, setSendRequestLoading] = useState(false)
  const [modal, setModal] = useState({ open: false, title: "", handleClose: () => setModal({ open: false }), onClick: null })

  const [quantity, setQuantity] = useState(null);
  const [row, setRow] = useState(null);
  const [seats, setSeats] = useState(null);
  const [section, setSection] = useState(null);
  const [totalCost, setTotalCost] = useState(null);
  const [isLimitedView, setIsLimitedView] = useState(false);
  const [isNonTransferrableLanguage, setIsNonTransferrableLanguage] = useState(false);
  const [deliveryMethodID, setDeliveryMethod] = useState(null);
  const [validForm, setValidForm] = useState(false);
  const [formErrors, setFormErrors] = useState({})

  const { signalREncorehive: signalRConnection } = useContext(SignalREncorehiveContext);

  let connection = signalRConnection;

  const getEventUrl = () => {
    return selectedSwarm.alternativeEventUrl || selectedEvent.entityLink?.href;
  };

  useEffect(() => {
    if (connection) {
      connection.on("NewJobPurchase", async function (res) {
        getUserBuys();
      });
    }
  }, [connection])

  useEffect(() => {
    getUserBuys()
  }, [selectedEvent]);

  useEffect(() => {
    const handleSwarmClosed = () => {
      let label = selectedEvent?.name.substring(0, 20) +
        "@" +
        selectedEvent?.venue?.name?.substring(0, 20) +
        " " +
        toStdDate(selectedEvent?.date)
      console.log("LABEL: ", label);
      setModal({
        open: true,
        title: <>{label}<br /> is no longer available</>,
        onClick: () => {
          dispatch(updateBeeSwarm({ ...selectedSwarm, hasBeenClosed: false, running: false }));
        },
        handleClose: () => {
          dispatch(updateBeeSwarm({ ...selectedSwarm, hasBeenClosed: false, running: false }));
          setModal({ open: false })
        }
      })
    }

    if (selectedSwarm.hasBeenClosed) {
      handleSwarmClosed()
    }

  }, [selectedSwarm, selectedEvent])

  useEffect(() => {

    const newFormErrors = {};

    const isValidQuantity = /^[1-9][0-9]*$/.test(quantity);
    console.log("isValidQuantity: ", isValidQuantity, "quantity: ", quantity)
    const isValidTotalCost = /^[0-9]+(\.[0-9]*)?$/.test(totalCost);

    if (!isValidQuantity && quantity) {
      newFormErrors.quantity = "Quantity must be a positive integer.";
    }

    if (totalCost != "" && !isValidTotalCost) {
      newFormErrors.totalCost = "Total Cost must be a positive numeric value.";
    }


    const remainingTickets = getRemainingTickets(selectedEvent, userBuysRes);
    if (
      parseInt(quantity) > parseInt(selectedEvent.useRunLevelLimit ? selectedEvent.runLimitNumberOfTickets : selectedEvent.eventLimitNumberOfTickets) ||
      parseInt(quantity) > remainingTickets
    ) {
      newFormErrors.quantity = "Tickets limits for this event have been exceeded.";
    }

    setFormErrors(newFormErrors);

    const isValidForm =
      Object.keys(newFormErrors).length === 0 &&
      quantity &&
      row &&
      seats &&
      section &&
      totalCost &&
      deliveryMethodID;

    setValidForm(isValidForm);
  }, [quantity, row, seats, section, totalCost, deliveryMethodID]);


  function getTicketsCanBuy(event, buys) {
    let ticketsCanBuy;
    if (event?.useRunLevelLimit) {
      ticketsCanBuy = (event?.runLimitNumberOfTickets - buys.sum_QtyPurchasedPerRun);
    } else {
      ticketsCanBuy =
        (event?.eventLimitNumberOfTickets - buys.sum_QtyPurchasedPerEvent);
    }
    return ticketsCanBuy >= 0 ? ticketsCanBuy : 0; // don't return negative values
  }

  function getRemainingTickets(event, buys) {
    if (!event || !Array.isArray(buys)) return 0;

    console.log("DEBUG: getRemainingTickets, event: ", event)
    console.log("DEBUG: getRemainingTickets, buys: ", buys)

    const isEventUsingRunLevelLimit = event.useRunLevelLimit;
    const eventId = isEventUsingRunLevelLimit ? event.runId : event.bteId;

    const buysForSelectedEvent = buys.find(buy =>
      isEventUsingRunLevelLimit ? buy.runId === eventId : buy.eventId === eventId
    );

    if (buysForSelectedEvent) {
      return getTicketsCanBuy(event, buysForSelectedEvent);
    } else {
      return isEventUsingRunLevelLimit ? event.runLimitNumberOfTickets : event.eventLimitNumberOfTickets;
    }
  }

  const RemainingTickets = ({ selectedEvent, userBuys }) => {

    return (
      <p>{selectedEvent ? getRemainingTickets(selectedEvent, userBuys) : null}</p>
    )
  }

  const resetInputs = () => {
    setQuantity('');
    setRow('');
    setSeats('');
    setSection('');
    setTotalCost('');
    setDeliveryMethod('');
    setIsLimitedView(false);
    setIsNonTransferrableLanguage(false);
  }

  useEffect(() => {
    resetInputs()
    console.log("resetting inputs")
  }, [selectedSwarm?.id]);

  const onSubmitBuyRequest = async (e) => {
    if (e.type === 'keydown' && e.key !== 'Enter')
      return;

    setSendRequestLoading(true)
    const swarmId = selectedSwarm.id;
    try {
      let createRes = await createBuyRequest({
        "SwarmId": swarmId,
        "quantity": quantity,
        "row": row,
        "seats": seats,
        "section": section,
        "totalCost": totalCost,
        "deliveryMethodID": deliveryMethodID,
        "isLimitedView": isLimitedView,
        "isNonTransferrableLanguage": isNonTransferrableLanguage
      }).unwrap();

      resetInputs();
      dispatch(updateBuyRequest(createRes));
      setSendRequestLoading(false);

      if (e.type === 'keydown' && e.key === 'Enter')
        firstInputRef?.current?.focus()
    } catch (error) {
      console.log("SWARMCARD: error sending Buy Request: ", JSON.stringify(error))
      showNotification(error?.data?.message || "Error Sending Buy Request", 'error');
      setSendRequestLoading(false);
      return;
    }
  }

  const titleStyles = {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column-reverse', sm: 'column-reverse', md: 'row', lg: 'row', xl: 'row', },
    margin: { xm: '0 0 0.5em 0', sm: '0', md: '0', lg: '0', xl: '0', },
  }

  const purchaseDetailsstyles = {
    marginBottom: '1em',
    paddingRight: { xs: '0', sm: '1em', md: '1em', lg: '1em', xl: '1em', },
    width: { xs: '100%', sm: '45%', md: '30%', lg: '100%', xl: '100%', },
    flexBasis: { sm: '50%', md: '33.3%', lg: '33.3%' }
  }

  const lastPurchaseDetailsstyles = {
    marginBottom: '1em',
    paddingRight: { xs: '0', sm: '1em', md: '1em', lg: '1em', xl: '0', },
    width: { xs: '100%', sm: '45%', md: '30%', lg: '100%', xl: '100%', },
    flexBasis: { sm: '50%', md: '33.3%', lg: '33.3%' }
  }

  function onlyNumberValidation(e) {
    if (e.target.value == "") setTotalCost("")
    if (!isNaN(parseFloat(e.target.value)) && isFinite(e.target.value)) {
      setTotalCost(e.target.value);
    }
  }

  function createPlatformTag(platformBackgroundColor, platformBorder, platformColor, platformLabel) {
    return (
      <Chip
        style={{ backgroundColor: platformBackgroundColor, border: platformBorder, borderRadius: "0.5em", color: platformColor, fontWeight: "600" }}
        label={platformLabel}
      />
    )
  }

  function displayPlatformName(primaryEventUrl) {

    if (primaryEventUrl != null) {

      const url = new URL(primaryEventUrl);
      const platformName = url.hostname.toLowerCase();

      if (platformName.includes("ticketmaster")) {
        return createPlatformTag("#026CDF", "", "#FFFFFF", "Ticketmaster");
      }
      else if (platformName.includes("livenation")) {
        return createPlatformTag("#E21836", "", "#FFFFFF", "Live Nation");
      }
      else if (platformName.includes("axs")) {
        return createPlatformTag("#0054A1", "", "#FFFFFF", "AXS");
      }
      else if (platformName.includes("evenue")) {
        return createPlatformTag("#FF0000", "", "#FFFFFF", "eVenue");
      }
      else if (platformName.includes("mlb")) {
        return createPlatformTag("#002D72", "solid 2px #D50032", "#FFFFFF", "MLB");
      }
      else if (platformName.includes("etix")) {
        return createPlatformTag("#369FD9", "", "#FFFFFF", "etix");
      }
      else if (platformName.includes("ticketweb")) {
        return createPlatformTag("#7E4299", "", "#FFFFFF", "TicketWeb");
      }
      else if (platformName.includes("tixr")) {
        return createPlatformTag("#000000", "", "#FFFFFF", "TIXR");
      }
      else if (platformName.includes("seatgeek")) {
        return createPlatformTag("#FF5B49", "", "#FFFFFF", "SeatGeek");
      }
      else if (platformName.includes("seetickets")) {
        return createPlatformTag("#00999A", "", "#FFFFFF", "Seetickets");
      }
      else {
        return createPlatformTag("#FFFFFF", "solid 2px #F29B1B", "#F29B1B", "Venue Platform");
      }

    }

  }

  const useRunLevelLimit = selectedEvent.useRunLevelLimit;

  return (
    <Card sx={{ display: "flex", margin: '0  0 2em 0', borderRadius: '1.5em' }}>
      <BasicModalInformation {...modal} />
      <Grid container sx={{ padding: '1.5em 1.5em 1.5em 1.5em ' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap:'wrap' }} >
          <div style={{ display: 'flex', margin: '0 1em 0.5em 0', height: '32px' }} >
            {useRunLevelLimit === true && (
              <Chip
                label="RUN LIMIT"
                style={{ backgroundColor: "orange", color: "white", fontWeight: "bolder", borderRadius: "0.5em", margin: "0 1em 0 0" }}
              />
            )}

            <div>
              {displayPlatformName(selectedEvent?.primaryEventUrl)}
            </div>

          </div>

          <Grid item sx={{ margin: '0 0 0.5em 0', display: 'flex', flexWrap:'wrap' }} >
            <p style={{ margin: "0 0.5em 0 0", fontSize: 'var(--p2)', fontWeight: '700', color: "var(--orange)", whiteSpace: 'nowrap' }}>Event Date:</p>
            <p style={{ fontSize: 'var(--p2)', whiteSpace: 'nowrap', fontWeight: '700' }}>{`${selectedEvent ? eventDatesFormatter(toStdDate(selectedEvent.date)) : 'Null'}`}</p>
          </Grid>

        </div>

        <Grid container sx={{ margin: '0 0 0.5em 0' }}>
          {/*----- TITLE & DATES-----*/}
          <Grid item sx={titleStyles}>
            <div style={{ display: 'flex' }} >
              <div>

                <a href={getEventUrl()} target="_blank" rel="noreferrer" style={{ display: 'flex' }} >
                  <h4
                    style={{ margin: "0 0.25em 0.5em 0", color: getEventUrl() ? '#1976D2' : '#888888', textDecorationLine: getEventUrl() ? 'underline' : null, fontWeight: '600' }} >
                    {`${selectedEvent?.name} - `} {`${selectedEvent?.venue?.name + ", " + selectedEvent?.venue?.city}`}
                  </h4>
                  <OpenInNewOutlinedIcon color="primary" />
                </a>

              </div>
              <IconButton
                sx={{ height: '28px', width: '28px', margin: ' 0 0.25em' }}
                color="primary"
                onClick={() => {
                  copyToClipBoard(getEventUrl())
                }}
              >
                <ContentCopyOutlinedIcon />
              </IconButton>

            </div>


          </Grid>
          {/*----- purchase details -----*/}
          <Grid item xs={12}>
            <Grid container sx={{ margin: '0 0 0.25em 0', alignItems: "center" }}>

              <Grid item sx={{ margin: '0 2em 0 0', display: 'flex', alignItems: "center" }} >
                <p style={{ margin: "0 0.5em 0.25em 0", fontWeight: '700', color: "var(--orange)" }}>Ticket limit:</p>
                <p>{`${selectedEvent?.useRunLevelLimit ? selectedEvent?.runLimitNumberOfTickets : selectedEvent?.eventLimitNumberOfTickets}`}</p>
              </Grid>

              {
                (selectedEvent?.eventLimit1PurchasePerBuyer || selectedEvent?.runLimit1PurchasePerBuyer)
                &&
                (<Grid item sx={{ margin: '0 2em 0 0', display: 'flex', alignItems: "center" }} >
                  <img src={OneTicketIcon} alt="1 Ticket Icon" />
                  <p style={{ fontWeight: "bold", margin: "0 0 0 0.3em" }}>One Purchase Limit</p>
                </Grid>)
              }

              <Grid item sx={{ margin: '0 2em 0 0', display: 'flex', alignItems: "center" }}>
                <p style={{ margin: "0 0.5em 0.25em 0", fontWeight: '700', color: "var(--orange)" }}>Remaining Tickets:</p>
                {
                  userBuysRes && !loadingUserBuys && !errorLoadingUserBuys && <RemainingTickets userBuys={userBuysRes} selectedEvent={selectedEvent} />
                }
              </Grid>

              <Grid item sx={{ margin: '0 2em 0 0', display: 'flex' }}>
                <p style={{ margin: "0 0.5em 0.25em 0", fontWeight: '700', color: "var(--orange)" }}>Reward:</p>
                <p>{`$${selectedSwarm?.reward} ${selectedSwarm?.rewardTypeId === 1 ? `Per Ticket` : `Total`}`}</p>
              </Grid>

              <Grid item sx={{ margin: '0 2em 0 0', display: 'flex' }}>
                <p style={{ margin: "0 0.5em 0.25em 0", fontWeight: '700', color: "var(--orange)" }}>Code:</p>
                <p>{`${selectedSwarm?.code || ''}`}</p>
              </Grid>

            </Grid>
          </Grid>

          {/*----- INSTRUCTIONS -----*/}
          <Grid item xs={12}>
            <p style={{ fontWeight: '700', color: "var(--orange)" }}>Instructions:</p>
          </Grid>
          <Grid item xs={12} style={{ margin: "0 0 0.25em 0" }} >
            <p>{`${selectedSwarm?.instructions || 'No instructions provided...'}`}</p>
          </Grid>

        </Grid>
        {/*----- DIVIDER -----*/}
        <Grid item xs={12}>
          <Divider sx={{ margin: '0 0 0.5em 0' }} />
        </Grid>

        {/*----- PURCHASE DETAILS FORMS -----*/}
        <Grid
          item
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: 'column', xl: 'column' },
            alignItems: 'flex-start'
          }}
        >
          <Grid container sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexWrap: { xs: 'wrap', sm: 'wrap', md: 'wrap', lg: 'wrap', xl: 'nowrap', }, }} >
            <Grid item sx={purchaseDetailsstyles}>
              <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)' }}>Quantity</p>
              <TextField
                variant="outlined"
                sx={{ width: '100%', padding: 0 }}
                value={quantity}
                type="number"
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  min: 1, // Ensure positive values
                  style: { padding: '.5em 1em' },
                }}
                onChange={e => setQuantity(e.target.value)}
                name="quantity"
                inputRef={firstInputRef}
                required
                error={Boolean(formErrors.quantity)}
                helperText={formErrors.quantity}
              />
            </Grid>
            <Grid item sx={purchaseDetailsstyles}>
              <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)' }}>Section</p>
              <TextField variant="outlined" sx={{ width: '100%' }} value={section} onChange={e => setSection(e.target.value)} name="section" required></TextField>
            </Grid>
            <Grid item sx={purchaseDetailsstyles}>
              <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)' }}>Row</p>
              <TextField variant="outlined" sx={{ width: '100%' }} value={row} onChange={e => setRow(e.target.value)} name="row" required></TextField>
            </Grid>
            <Grid item sx={purchaseDetailsstyles}>
              <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)' }}>Seats</p>
              <TextField variant="outlined" sx={{ width: '100%' }} value={seats} onChange={e => setSeats(e.target.value)} name="seats" required></TextField>
            </Grid>
            <Grid item sx={purchaseDetailsstyles}>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }} >
                <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)' }}>Delivery Method</p>
              </div>
              <div style={{ display: "flex", alignItems: 'center', width: '100%' }}>
                <Select
                  value={deliveryMethodID}
                  defaultValue={"default"}
                  variant="outlined"
                  sx={{ width: '100%', height: '41px' }}
                  name="Delivery Method"
                  onChange={(e) => setDeliveryMethod(e.target.value)}
                >
                  {(deliveryMethods || []).map(({ name, id }) => (
                    <MenuItem value={id} key={id} >{name}</MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item sx={lastPurchaseDetailsstyles}>
              <p style={{ margin: "0 0 0.5em 0", fontSize: 'var(--p2)', whiteSpace: 'nowrap' }}>Total Cost</p>
              <TextField
                sx={{ width: '100%', }}
                value={totalCost}
                onChange={onlyNumberValidation}
                name="totalCost"
                required
                error={Boolean(formErrors.totalCost)}
                helperText={formErrors.totalCost}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]',
                  step: "1",
                  min: 0,
                }}
              />
            </Grid>
          </Grid>
          <Grid container sx={{ display: 'flex', justifyContent: 'space-between' }}>

            <div style={{ display: 'flex' }}>

              <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  label="Obstructed/Limited View"
                  id="limitedView"
                  type="checkbox"
                  name="Obstructed/Limited View"
                  value={isLimitedView}
                  checked={isLimitedView}
                  onChange={e => setIsLimitedView(e.target.checked)}
                  onKeyDown={e => {
                    if (e.key === 'Enter')
                      setIsLimitedView(!e.target.checked)
                  }}
                />
                <label htmlFor="limitedView">
                  <p>Obstructed/Limited View</p>
                </label>
              </Grid>

              <Grid item sx={{ display: 'flex', alignItems: 'center', marginLeft: '3em' }}>
                <Checkbox
                  label="Non-Transferrable Language"
                  id="nonTransferrableLanguage"
                  type="checkbox"
                  name="Non-Transferrable Language"
                  value={isNonTransferrableLanguage}
                  checked={isNonTransferrableLanguage}
                  onChange={e => setIsNonTransferrableLanguage(e.target.checked)}
                  onKeyDown={e => {
                    if (e.key === 'Enter')
                      setIsNonTransferrableLanguage(!e.target.checked)
                  }}
                />
                <label htmlFor="nonTransferrableLanguage">
                  <p>Non-Transferrable Language</p>
                </label>
              </Grid>

            </div>

            <Grid item>
              <Button
                disabled={sendRequestLoading || !validForm}
                variant="contained"
                size="large"
                sx={{ whiteSpace: 'nowrap', width: '130px' }}
                onClick={onSubmitBuyRequest}
                onKeyDown={onSubmitBuyRequest}
              >
                {sendRequestLoading && validForm ? (
                  <CircularProgress size={24} />
                ) : (
                  'Send Request'
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

export default SwarmCard;